import React, { Suspense } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";

import { Manifest } from "services/action";
import { Page } from "ui/components";
import { LegList } from "./component";

const Maps = React.lazy(() => import("ui/components/maps/manifest"));

const ManifestScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const History = useHistory();

  const [data, setData] = React.useState(null);

  const $onLoad = async (e) => {
    const req = await Dispatch(Manifest.$get(e));

    if (req?.message === "success") {
      setData(req?.data);
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, [match]);

  if (data?.status === "new") {
    return (
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div style={{ fontSize: 25 }} className="text-primary fw-semibold">
          ...Oops
        </div>
        <div style={{ fontSize: 16 }} className="text-secondary fw-semibold">
          Manifest Belum Di Publish
        </div>

        <Button
          type="button"
          variant="primary"
          className="fs-7 mt-3"
          onClick={() => window.location.reload()}
        >
          Refresh
        </Button>
      </div>
    );
  }

  const Start = () => {
    return (
      <div className="col">
        <Button
          type="button"
          variant="success"
          className="w-100 fs-7"
          onClick={() =>
            History.push(`/pod/${data?.id}/start`, {
              data: data,
              code: data?.code,
            })
          }
        >
          Mulai Manifest
        </Button>
      </div>
    );
  };

  return (
    <Page
      title={`Manifest ${data?.type
        ?.replace("_", " ")
        ?.replace("console", "transit")}`}
      full
      action={
        <div>
          {data?.status === "new" && (
            <div className="bg-warning-lt w-100 border-warning border text-dark py-1 rounded fs-7 fw-semibold">
              Manifest Belum Dipublish{" "}
            </div>
          )}

          {data?.status === "published" && <Start />}
        </div>
      }
    >
      <Suspense fallback={<div>Loading...</div>}>
        <Maps legs={data?.legs} centerDynamic={false} />
      </Suspense>

      <div className="mt-2">
        <LegList
          data={data?.legs}
          manifestID={data?.id}
          status={data?.status}
          trucking={data?.is_trucking}
          type={data?.type}
        />
      </div>
    </Page>
  );
};

export default ManifestScreen;
